// extracted by mini-css-extract-plugin
export default {"loginform":"Login_loginform__dHpIy","headerTitle":"Login_headerTitle__4xkMm","row":"Login_row__bHR0n","buttonRow":"Login_buttonRow__A0WDN"};